/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPageHero from './components/IndexPageHero';
import BlogOverview from 'flarum/v17development/blog/pages/BlogOverview';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default function () {
	if (app.initializers.has('v17development-flarum-blog')) {
		extend(BlogOverview.prototype, 'view', function (vnode) {
			const children = Array.isArray(vnode) ? vnode : vnode.children;

			const title = t('glowingblue-newvigation.forum.blog_page.hero.title');
			const icon = 'fas fa-blog';

			children[0] = <IndexPageHero title={title} icon={icon} />;
		});
	}
}
